import { useCallback } from "react";
import { MODALS } from "../config/params";
import { useModal } from "../context/ModalContext";
import { useUserStore } from "./redux-hooks/user-store/user.store";
import { openExternalLink } from "../utils";

export const useVetCoveRedirect = () => {
  const { openModal } = useModal();
  const { user } = useUserStore();

  const handleVetCoveLink = useCallback((url?: string | null, fallbackUrl?: string) => {
    const actionUrl = url || fallbackUrl || "";
    if (user?.isVetCoveRedirectDismissed) {
      openExternalLink(actionUrl);
    } else {
      openModal(MODALS.VETCOVE_REDIRECT_MODAL, undefined, { actionUrl });
    }
  }, [openModal, user?.isVetCoveRedirectDismissed]);

  return { handleVetCoveLink };
};
